import { MicrouniversoApi } from "./classes/MicrouniversoApi";

const microuniversoApi = new MicrouniversoApi()

export default microuniversoApi